import * as React from 'react';
export var CheckboxContext = React.createContext(null);
export var useCheckbox = function () { return React.useContext(CheckboxContext); };
